pageId = 'reports-answers-show'

$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  tower.adjustAuthor()
  tower.adjustAttachment()
  tower.adjustCommentsLike()
  tower.foldComments()

  $page.find('.detail-action-edit').on 'click', ->
    $('.link-edit-answer').trigger('click')
